require('bootstrap/dist/js/bootstrap.bundle');

class Evedo {
    constructor(userId, cityId, lat, lng, texts) {
        this.searchInput = null;
        this.searchInputWidth = 0;
        this.mapLoaded = false;
        this.map = null;

        this.linkedEventsInited = false;
        this.linkedEventsOpenedList = false;


        this.messageModal = null;

        this.locked = false;
        this.texts = {};
        this.socialUrls = {
            facebook: null,
            twitter: null,
            google: null
        };

        this.texts = texts;
        this.userId = userId;
        this.cityId = cityId;
        this.lat = lat;
        this.lng = lng;
        this.loadingLocked = false;

        // global properties
        this.dateFormat = 'mm/dd/yy';
        this.pixelRatio = window.devicePixelRatio;

        this.registerFormCaptchaWidged = null;

        // navbar
        this.initNavbar();

        var that = this;

        // setTimeout(function() {
        //     that._refresh();
        // }, 30000);

        // scroll
        $(window).bind('scroll', { target: this }, this.scrollHandler);
    }

    mobileDevice() {
        var a = navigator.userAgent || navigator.vendor || window.opera;
        return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)));
    }

    _lock() {
        this.locked = true;
    }

    _unlock() {
        this.locked = false;
    }

    _refresh() {
        var that = this;
        if (isNaN(parseInt(that.userId)) || !parseInt(that.userId) || that.loadingLocked)
            return false;
        that.loadingLocked = true;
        $.ajax({
            url: "/messages/check/",
            dataType: 'json',
            type: 'post',
            data: {

            },
            success: function(data) {
                for (var uid in data.messages) {
                    if (data.messages[uid][0] > 0) {
                        $('.header-messages-count').html(data.messages[uid][0]).show();
                    }
                }

            }
        });

        var lastId = 0;
        $.each($('div.notifications-dropdown ul.notifications li'), function (value) {
            if ($(this).data('notification') != undefined) {
                lastId = $(this).data('notification');
                return false;
            }
        });

        $.ajax({
            url: "/notifications/load/",
            dataType: 'json',
            type: 'post',
            data: {
                newCount: $('.header-notifications-count').html(),
                lastId: lastId
            },
            success: function(data) {
                if (data != undefined && data.unreadNotificationsCount != undefined && data.unreadNotificationsCount > 0 && data.notificationsBlock != undefined) {
                    $('.header-notifications-count').html(data.unreadNotificationsCount).show();
                    $('div.notifications-dropdown ul.notifications').html(data.notificationsBlock);
                } else if (data.length == 0) {
                    $('.header-notifications-count').html(0).show();
                    $('.header-notifications-count').attr('style', 'display: none;');
                }
                that.loadingLocked = false;
            }
        });

        setTimeout(function() {
            that._refresh();
        }, 30000);
    }

    ignoreNotification(notification) {
        $(".notification-" + notification).remove();
        var count = parseInt($(".header-notifications-count").html());
        count = Math.max(0, count - 1);
        $(".header-notifications-count").html(count);
        if (!count) {
            $(".header-notifications-count").parent().click();
            $(".header-notifications-count").parent().data("toggle", null);
            $(".header-notifications-count").parent().attr("href", "/notifications");
            $(".header-notifications-count").hide();
        }
        
        var settings = undefined;
        var cookieContent = $.cookie("user_" + this.userId + "_settings");
        if(cookieContent != undefined){
            settings = $.parseJSON(cookieContent);
        }
       
        if (settings == undefined || !settings || !settings.hiddenNotifications) {
            settings = {
                hiddenNotifications: {}
            };
        }

        settings.hiddenNotifications[notification] = true;
        $.cookie("user_" + this.userId + "_settings", JSON.stringify(settings), {expires: 30, path: '/' });
    }

    disablePageScrolling() {
        this.pageScrollingDisabled = true;
        this.windowScrollPositionX = $(window).scrollLeft();
        this.windowScrollPositionY = $(window).scrollTop();

        $('html').addClass('disable-scrolling');
        $(window).scrollLeft(this.windowScrollPositionX);
        $(window).scrollTop(this.windowScrollPositionY);
    }

    enablePageScrolling() {
        if (this.pageScrollingDisabled) {
            this.pageScrollingDisabled = false;

            $('html').removeClass('disable-scrolling');
        }
    }

    initNavbar() {
        if (!$('.navbar')[0]) return;

        var that = this;

        // search
        this.searchInput = $('.navbar').find('input#navbar-search');

        // this.searchInputWidth = (this.searchInput.outerWidth()) + 30;

        // var defaultSearchInputWidth = this.searchInput.outerWidth();

        if (this.searchInput[0] != null) {
            this.searchInput
            .focus(function() {
                // that.searchInput.width(that.searchInputWidth + 'px');
            }).blur(function() {
                // that.searchInput.width(defaultSearchInputWidth + 'px');
            }).autocomplete({
                appendTo: '.navbar-main',
                autoFocus: true,
                delay: 200,
                minLength: 3,
                source: '/search-basic/search/',
                focus: function(event, ui) {
                    return false;
                },
                select: function(event, ui) {
                    window.location.href = ui.item.url;
                    return false;
                }
            });

            this.searchInput.data('ui-autocomplete')._renderItem = function(ul, item) {
                if (item.category == 'advanced') {
                    return $('<li class="advanced"></li>')
                    .data('item.autocomplete', item)
                    .append('<a href="' + item.url + '">' + item.description + '</a>')
                    .appendTo(ul);
                } else {
                    return $('<li class="item"></li>')
                    .data('item.autocomplete', item)
                    .append('<a href="' + item.url + '"><img src="' + item.image + '"><strong' + (item.verified == 1 ? ' class="verified"' : '') + '>' + item.label + '</strong>' + item.description + '</a>')
                    .appendTo(ul);
                }
            };

            this.searchInput.data('ui-autocomplete')._renderMenu = function(ul, items) {
                var self = this, currentCategory = '';

                $.each(items, function(index, item) {
                    if (item.category != currentCategory && item.category != 'advanced') {
                        ul.append('<li class="ui-autocomplete-category">' + item.category + '</li>' );
                        currentCategory = item.category;
                    }

                    self._renderItem(ul, item);
                });

                // ul.addClass('search-autocomplete').css({ maxWidth: that.searchInputWidth });
            };
        }

    //     // submenus
    //     $('.navbar').find('li.submenu').each(function() {
    //         $(this).mouseover(function() {
    //             $(this).find('a:eq(0)').addClass('active');
    //             $(this).find('ul.dropdown-menu').css('display', 'block');
    //         });

    //         $(this).mouseout(function() {
    //             $(this).find('a:eq(0)').removeClass('active');
    //             $(this).find('ul.dropdown-menu').css('display', 'none');
    //         });
    //     });

    //     // shadow
    //     this.navShadowElement = $('.navbar');
    //     this.navShadowScrollOffset = 25;
    //     this.navShadowHidden = '0px 1px 3px rgba(0, 0, 0, 0.12)';
    //     this.navShadowShown = '0px 2px 10px rgba(0, 0, 0, 0.2)';

    //     this.navShadowElement.addClass('navigation-shadow-transition');
    }

// Linked events

    openLinkedEvents() {
        var that = this;

        // init once
        if (!this.linkedEventsInited) {
            this.linkedEventsInited = true;

            this.linkedEventsModal = $('#linked-events-modal');
            this.linkedEventsModalListsNavigation = $('div.lists-nav', this.linkedEventsModal);
            this.linkedEventsModalListsContent = $('ul.lists-content', this.linkedEventsModal);
            this.linkedEventsModalEventsNavigation = $('div.events-nav', this.linkedEventsModal);
            this.linkedEventsModalEventsSearch = $('input', this.linkedEventsModalEventsNavigation);
            this.linkedEventsModalEventsContent = $('ul.events-content', this.linkedEventsModal);

            this.linkedEventsModal.on('hidden', function() {
                that.closeLinkedEventsList();
            });

            $('form', this.linkedEventsModalListsNavigation).submit(function() {
                var input = $('input', this);

                if ($.trim(input.val()).length) {
                    that.createLinkedEventList($.trim(input.val()));
                }

                input.val('').focus();
            });

            $('a.btn-back', this.linkedEventsModalEventsNavigation).click(function() {
                that.closeLinkedEventsList($(this).data('id'));
                return false;
            });

            this.linkedEventsModalEventsSearch
                .focus(function() { $(this).attr('placeholder', that.texts.searchEventsFocused); })
                .blur(function() { $(this).attr('placeholder', that.texts.searchEvents); })
                .autocomplete({
                    appendTo: that.linkedEventsModal,
                    autoFocus: true,
                    delay: 200,
                    minLength: 2,
                    source: function( request, response ) {
                        $.ajax({
                            url: "/common/token-myevents/",
                            dataType: "json",
                            data: { q: that.linkedEventsModalEventsSearch.val(), linked: 1 },
                            success: function( data ) {
                                response( $.map( data, function( item ) {
                                    return {
                                        id: item.id,
                                        image: item.image,
                                        label: item.name,
                                        value: item.name,
                                        date: item.date,
                                        city: item.city
                                    };
                                }));
                            }
                        });
                    },
                    focus: function(event, ui) {
                        return false;
                    },
                    select: function(event, ui) {
                        that.addEventToLinkedEventsList($('a.btn-back', that.linkedEventsModalEventsNavigation).data('id'), ui.item.id);
                        that.linkedEventsModalEventsSearch.val('').blur();
                        return false;
                    }
                });

            this.linkedEventsModalEventsSearch.data('ui-autocomplete')._renderItem = function(ul, item) {
                return $('<li class="autocomplete-image-item"></li>')
                    .data('item.autocomplete', item)
                    .append('<a href="#"><img src="' + item.image + '"><strong>' + item.label + '</strong><span>·</span>' + item.date + '<span>·</span>' + item.city + '</a>')
                    .appendTo(ul);
            };
        }

        $('#events-menu').parent().removeClass('open');
        this.linkedEventsModal.show();

        $('input', this.linkedEventsModal).val('');
        this.linkedEventsModalListsContent.html('');
        this.linkedEventsModalEventsContent.html('');

        this.loadLinkedEventsLists();
    }

    loadLinkedEventsLists() {
        if (this.locked) return;

        var that = this;
        this._lock();

        $.ajax({
            url: '/events/linked-lists/',
            dataType: 'json',
            type: 'post',
            success: function(data) {
                if (!data.count) {
                    that.linkedEventsModalListsContent.html('<li class="message">' + that.texts.noLists + '</li>');
                }
                else {
                    that.linkedEventsModalListsContent.html(data.body).scrollTop(0);
                    that.initLinkedEventsLists();
                }

                that._unlock();
            },
            error: function() {
                that._unlock();
            }
        });
    }

    initLinkedEventsLists(target) {
        var that = this;
        target = (!target) ? $('li.linked-list', this.linkedEventsModalListsContent) : target;

        target.each(function() {
            var id = $(this).data('id');
            var item = $(this);
            var deleteButton = $('a:last', $(this));

            item.click(function() {
                that.openLinkedEventsList(id);
            });

            deleteButton.click(function() {
                if (!deleteButton.hasClass('confirm')) {
                    deleteButton.addClass('confirm').text(that.texts.pressToConfirm);

                    item.bind('mouseleave', function() {
                        deleteButton.removeClass('confirm').text(that.texts.deleteList);
                        item.unbind('mouseleave');
                    });
                }
                else {
                    deleteButton.removeClass('confirm').text(that.texts.deleteList);
                    item.unbind('mouseleave');
                    that.deleteLinkedEventsList(id, item);
                }

                return false;
            });
        });
    }

    createLinkedEventList(listName) {
        if (this.locked) return;
        var that = this;
        this._lock();

        $.ajax({
            url: '/events/linked-lists/save/',
            dataType: 'json',
            type: 'post',
            data: { name: listName },
            success: function(data) {
                if (data.success) {
                    that.linkedEventsModalListsContent.find('li.message').remove();
                    that.linkedEventsModalListsContent.append(data.body);

                    var addedList = $('li.linked-list:last-child', that.linkedEventsModalListsContent);
                    that.initLinkedEventsLists(addedList);

                    that.linkedEventsModalListsContent.animate(
                        { scrollTop: that.linkedEventsModalListsContent[0].scrollHeight },
                        { duration: 250, queue: false }
                    );

                    addedList.addClass('highlighted');
                    window.setTimeout(function() { addedList.removeClass('highlighted'); }, 500);
                }

                that._unlock();
            },
            error: function() {
                that._unlock();
            }
        });
    }

    updateLinkedEventList(listId) {
        var that = this;

        $.ajax({
            url: '/events/linked-lists/',
            dataType: 'json',
            type: 'post',
            data: { id: listId },
            success: function(data) {
                if (data.count) {
                    var old = $('li[data-id="' + listId + '"]', that.linkedEventsModalListsContent);
                    that.initLinkedEventsLists($(data.body).insertAfter(old));
                    old.remove();
                }
            }
        });
    }

    deleteLinkedEventsList(listId, target) {
        if (this.locked) return;

        var that = this;
        this._lock();

        $.ajax({
            url: '/events/linked-lists/delete/',
            dataType: 'json',
            type: 'post',
            data: { id: listId },
            success: function(data) {
                if (data.success) {
                    target.animate({ marginLeft: 640 }, { duration: 250 }).slideUp(300, function() {
                        target.remove();
                    });

                    if (!($('li.linked-list', that.linkedEventsModalListsContent).length - 1)) {
                        that.linkedEventsModalListsContent.append('<li class="message">' + that.texts.noLists + '</li>');
                    }

                    that.linkedEventsModalListsContent.addClass('hide-scroll');
                    window.setTimeout(function() { that.linkedEventsModalListsContent.removeClass('hide-scroll'); }, 600);
                }

                that._unlock();
            },
            error: function() {
                that._unlock();
            }
        });
    }

    openLinkedEventsList(listId) {
        if (this.locked) return;

        var that = this;
        this._lock();

        $.ajax({
            url: '/events/linked-events/',
            dataType: 'json',
            type: 'post',
            data: { id: listId },
            success: function(data) {
                if (!data.count) {
                    that.linkedEventsModalEventsContent.html('<li class="message">' + that.texts.noEvents + '</li>');
                }
                else {
                    that.linkedEventsModalEventsContent.html(data.body).scrollTop(0);
                    that.initLinkedEvents();
                }

                that.linkedEventsModalListsNavigation.css('left', -640);
                that.linkedEventsModalListsContent.css('left', -640);
                that.linkedEventsModalEventsNavigation.css('left', 0);
                that.linkedEventsModalEventsContent.css('left', 0);

                $('a.btn-back', that.linkedEventsModalEventsNavigation).data('id', listId);
                $('h3', that.linkedEventsModalEventsNavigation).text(data.name);

                that.linkedEventsOpenedList = true;
                that._unlock();
            },
            error: function() {
                that._unlock();
            }
        });
    }

    initLinkedEvents(target) {
        var that = this;
        target = (!target) ? $('li.event', this.linkedEventsModalEventsContent) : target;

        target.each(function() {
            var item = $(this);
            var id = $(this).data('event-id');
            var deleteButton = $('a:last', $(this));

            item.click(function() {
                window.open(item.data('url'), '_blank');
            });

            deleteButton.click(function() {
                if (!deleteButton.hasClass('confirm')) {
                    deleteButton.addClass('confirm').text(that.texts.pressToConfirm);

                    item.bind('mouseleave', function() {
                        deleteButton.removeClass('confirm').text(that.texts.deleteFromList);
                        item.unbind('mouseleave');
                    });
                }
                else {
                    deleteButton.removeClass('confirm').text(that.texts.deleteFromList);
                    item.unbind('mouseleave');
                    that.deleteEventFromLinkedEventsList(id, item);
                }

                return false;
            });
        });
    }

    addEventToLinkedEventsList(listId, eventId) {
        if (this.locked) return;

        var that = this;
        this._lock();

        $.ajax({
            url: '/events/linked-events/save/',
            dataType: 'json',
            type: 'post',
            data: { list: listId, event: eventId },

            success: function(data) {
                if (data.success) {
                    that.linkedEventsModalEventsContent.find('li.message').remove();
                    that.linkedEventsModalEventsContent.append(data.body);

                    var addedEvent = $('li.event:last-child', that.linkedEventsModalEventsContent);
                    that.initLinkedEvents(addedEvent);

                    that.linkedEventsModalEventsContent.animate(
                        { scrollTop: that.linkedEventsModalEventsContent[0].scrollHeight },
                        { duration: 250, queue: false }
                    );

                    addedEvent.addClass('highlighted');
                    window.setTimeout(function() { addedEvent.removeClass('highlighted'); }, 500);
                }

                that._unlock();
            },
            error: function() {
                that.linkedEventsModalEventsSearch.focus();
                $('div.tip', that.linkedEventsModal).css('top', 110);
                window.setTimeout(function() { $('div.tip', that.linkedEventsModal).css('top', 155); }, 4000);

                that._unlock();
            }
        });
    }

    deleteEventFromLinkedEventsList(eventId, target) {
        if (this.locked) return;

        var that = this;
        this._lock();

        $.ajax({
            url: '/events/linked-events/delete/',
            dataType: 'json',
            type: 'post',
            data: { id: eventId },
            success: function(data) {
                if (data.success) {
                    target.animate({ marginLeft: 640 }, { duration: 250 }).slideUp(300, function() {
                        target.remove();
                    });

                    if (!($('li.event', that.linkedEventsModalEventsContent).length - 1)) {
                        that.linkedEventsModalEventsContent.append('<li class="message">' + that.texts.noEvents + '</li>');
                    }

                    that.linkedEventsModalEventsContent.addClass('hide-scroll');
                    window.setTimeout(function() { that.linkedEventsModalEventsContent.removeClass('hide-scroll'); }, 600);
                }

                that._unlock();
            },
            error: function() {
                that._unlock();
            }
        });
    }

    closeLinkedEventsList(listId) {
        if (this.locked || !this.linkedEventsOpenedList) return;

        var that = this;
        this._lock();

        if (listId) {
            this.updateLinkedEventList(listId);
        }

        this.linkedEventsModalListsNavigation.css('left', 0);
        this.linkedEventsModalListsContent.css('left', 0);
        this.linkedEventsModalEventsNavigation.css('left', 640);
        this.linkedEventsModalEventsContent.css('left', 640);

        window.setTimeout(function() {
            $('a.btn-back', that.linkedEventsModalEventsNavigation).data('id', null);
            $('h3', that.linkedEventsModalEventsNavigation).text('');

            that.linkedEventsOpenedList = false;
            that._unlock();
        }, 500);
    }


// Messages

    _createMessageModal() {
        var str  = '<div class="standard modal hide" id="message-modal" data-bs-backdrop="true" tabindex="-1" role="dialog" aria-labelledby="message-modalLabel" aria-hidden="true">'
        str    += '<div class="modal-dialog" role="document">'
        str    += '<div class="modal-content">'
        str    += '<div class="modal-header"><h3 class="title"></h3><button class="close" data-bs-dismiss="modal" type="button"></button></div>';
        str    += '<form data-bs-backdrop="static" tabindex="-1" onsubmit="window.evedo.doSendMessage(); return false;">';
      
        str    += '<div class="modal-body">'
        str    += '<input type="hidden" class="input-id" />';
        str    += '<div class="block hide message" id="message"></div>';
        str    += '<div class="block"><textarea class="form-control"></textarea></div>';
        str    += '</div>';
        str    += '<div class="modal-footer actions"><button class="btn btn-primary" type="submit" id="button-submit">' + this.texts.send + '</button></div>';
        str    += '</form>'; 
        str    += '</div>';
        str    += '</div>';
        str    += '</div>';
       
        this.messageModal = $(str);
        $("body").append(this.messageModal);
    }

    sendMessage(userId, userName) {
        var that = this;

        if (!this.messageModal) this._createMessageModal();
        $(".title", this.messageModal).html(this.texts.messageTo + ' ' + userName);
        $(".input-id", this.messageModal).val(userId);
        $("textarea", this.messageModal).val('');
        setTimeout(function () {
            $("textarea", that.messageModal).focus();
        }, 300);
        this.messageModal.show();
    }

    doSendMessage() {
        var userId = $(".input-id", this.messageModal).val();
        var text = $("textarea", this.messageModal).val();
        if (!text.length) return;

        var that = this;

        $.ajax({
            url: "/messages/send/",
            dataType: 'json',
            type: 'post',
            data: {user_id: userId, text: text},
            success: function(data) {
                that.messageModal.hide();
            }
        });
    }

// Mail

    sendActivationMail() {
        $.ajax({
            url: "/profile/send-activation-mail/",
            dataType: 'json',
            type: 'post',
            success: function(data) {
                // if (data && data.status != undefined && data.status) {
                //     $(".notification-verify").hide();
                //     $(".notification-verify").siblings('span').remove();
                // }
            }
        });
    }

// Scroll

    scrollHandler(e) {
        var that = e.data.target;

        // window.clearTimeout(that.scrollHandlerTimeout);
        // that.scrollHandlerTimeout = setTimeout(function() {
            that.throttledScrollHandler();
        // }, 5);
    }

    throttledScrollHandler() {
        var that = this;
        var scroll = $(window).height() < $(document).height();
        var scrollTop = $(window).scrollTop();

        // this.navShadowElement.css('boxShadow', (scroll && scrollTop > this.navShadowScrollOffset) ? this.navShadowShown : this.navShadowHidden);
        // this.topButton.css('right', (scroll && scrollTop > 100) ? '0px' : '-30px');

        if (this.scrollHandlerBlock) {
            if (window.requestAnimationFrame) {
                window.requestAnimationFrame(function() {
                    that.scrollHandlerBlock(scrollTop);
                });
            }
            else {
                that.scrollHandlerBlock(scrollTop);
            }
        }
    }

    addScrollHandlerBlock(block) {
        if (!block) {
            this.scrollHandlerBlock = null;
        }
        else {
            this.scrollHandlerBlock = block;
        }
    }

// Socials

    openFacebook () {
        var that = this;
        if (this.socialUrls.facebook == null) {
            $.ajax({
                url: "/common/facebook-url/",
                dataType: 'json',
                method: 'post',
                async: false,
                data: {},
                success: function(data) {
                    if (data.url) {
                       that.socialUrls.facebook = data.url;
                    } else {
                        return;
                    }
                },
                error: function(data) {
                    return data;
                }
            });
        }
        if (this.socialUrls.facebook == null) return;
        window.social = 'facebook';

        window.open(this.socialUrls.facebook, "fbwindow", "width=800,height=410,toolbar=0,scrollbars=0,status=0,resizable=0,location=0,menuBar=0,left=" + ((screen.width - 800) /2) + ",top=" + ((screen.height - 410) / 2));
    }

    openTwitter() {
        var that = this;
        if (this.socialUrls.twitter == null) {
            $.ajax({
                url: "/common/twitter-url/",
                dataType: 'json',
                method: 'post',
                async: false,
                data: {},
                success: function(data) {
                    if (data.url) {
                        that.socialUrls.twitter = data.url;
                    } else {
                        return;
                    }
                }
            });
        }
        if (this.socialUrls.twitter == null) return;
        window.social = 'twitter';
        window.open(this.socialUrls.twitter, "fbwindow", "width=800,height=410,toolbar=0,scrollbars=0,status=0,resizable=0,location=0,menuBar=0,left=" + ((screen.width - 800) /2) + ",top=" + ((screen.height - 745) / 2));
    }

    openGoogle() {
        var that = this;
        if (this.socialUrls.google == null) {
            $.ajax({
                url: "/common/google-url/",
                dataType: 'json',
                method: 'post',
                async: false,
                data: {},
                success: function(data) {
                    if (data.url) {
                        that.socialUrls.google = data.url;
                    } else {
                        return;
                    }
                }
            });
        }
        if (this.socialUrls.google == null) return;
        window.social = 'google';
        window.open(this.socialUrls.google, "fbwindow", "width=800,height=500,toolbar=0,scrollbars=0,status=0,resizable=0,location=0,menuBar=0,left=" + ((screen.width - 800) /2) + ",top=" + ((screen.height - 500) / 2));
    }

// Login / Registration / Forgotten pasword

    isLogged() {
        return this.userId ? this.userId : false;
    }

    openLogin(message) {
        $("#login-modal").show();
        this.toggleLoginForms('login', message);
    }

    openRegistration(message) {
        var that = this;

        $("#login-modal").show();
        this.toggleLoginForms('register', message);
        that.registerFormCaptchaLoad();
    }


    openForgottenPassword() {
        $("#login-modal").show();
        this.toggleLoginForms('forgotten', '');
    }

    closeLogin(){
        $("#login-modal").hide();
    }

    toggleLoginForms (form, message) {
        switch(form) {
            case 'forgotten':
                $('form#forgotten').css('display', 'block');
                $('form#login').css('display', 'none');
                $('form#register').css('display', 'none');

                $('.login').css('display', 'none');
                $('.register').css('display', 'block');
                break;

            case 'login':
                $('form#forgotten').css('display', 'none');
                $('form#login').css('display', 'block');
                $('form#register').css('display', 'none');

                $('.login').css('display', 'block');
                $('.register').css('display', 'none');
                break;

            case 'register':
                $('form#forgotten').css('display', 'none');
                $('form#login').css('display', 'none');
                $('form#register').css('display', 'block');
                
                $('.login').css('display', 'none');
                $('.register').css('display', 'block');
                break;
        }

        if (message == null || message == '') {
            $("p", "#login-modal").css('display', 'none');
        }
        else {
            $("p", "#login-modal").css('display', 'block').text(message);
        }
    }

    loginRequest() {
        var form = $('form#login');
        form.on('submit',function(e){ e.preventDefault(); });

        var email = form.find('input[name="email"]');
        var password = form.find('input[name="password"]');
        var remember = form.find('input[name="remember"]');
        var message = form.find('label.warning');

        $.ajax({
            url: "/login/",
            dataType: 'json',
            method: 'post',
            data: {
                email: email.val(),
                password: password.val(),
                remember: remember.is(':checked'),
                hash: window.location.hash
            },

            success: function(data) {
                if (!data.status) {
                    message.text(data.error).show();
                }
                else {
                    if(window.location == data.referrer) {
                        window.location.reload();
                    }
                    else {
                        window.location = data.referrer;
                    }
                }
            },
            error: function(data){
                // TODO FIXME this is returning a 200 but resolving as an error
                if (!data.status) {
                    message.text(data.error).show();
                }
                else {
                    window.location.reload();
                }
            }
        });
    }

    registerFormCaptchaLoad(){
        var that = this;

        if(window.googleRecaptchaSiteKey==null || window.googleRecaptchaSiteKey.trim()===""){
            return;
        }

        if(that.registerFormCaptchaWidged == null){
            that.registerFormCaptchaWidged = grecaptcha.render('g-recaptcha-container', {
              'sitekey' : window.googleRecaptchaSiteKey
            });    
        }else{
            grecaptcha.reset(that.registerFormCaptchaWidged);
        }
    }

    registerRequest() {
        var that = this;
        var form = $('form#register');
        form.on('submit',function(e){ e.preventDefault(); });

        var name = form.find('input[name="name"]');
        var email = form.find('input[name="email"]');
        var password1 = form.find('input[name="password1"]');
        var password2 = form.find('input[name="password2"]');
        var terms = form.find('input[name="terms"]');
        var remember = form.find('input[name="remember"]');
        var message = form.find('label.warning');
        var captcha = "";
        if(that.registerFormCaptchaWidged != null){
            var captcha = grecaptcha.getResponse(that.registerFormCaptchaWidged);
        }

        $.ajax({
            url: "/register/",
            dataType: 'json',
            method: 'post',
            data: {
                name: name.val(),
                email: email.val(),
                password1: password1.val(),
                password2: password2.val(),
                terms: terms.is(':checked'),
                remember: remember.is(':checked'),
                hash: window.location.hash,
                captcha: captcha
            },

            success: function(data) {
                if (!data.status) {
                    message.text(data.error).show();
                    that.registerFormCaptchaLoad();
                }
                else {
                    window.evedo.sendToAlphaSignupMailChimp(email.val(),name.val());
                    if(window.location == data.referrer) {
                        window.location.reload();
                    }
                    else {
                        window.location = data.referrer;
                    }
                }
            },
            error: function(data){
                // TODO FIXME this is returning a 200 but resolving as an error
                if (!data.status) {
                    message.text(data.error).show();
                }
                else {
                    window.location.reload();
                }
            }
        });
    }

    forgottenPasswordRequest() {
        var form = $('form#forgotten');
        form.on('submit',function(e){ e.preventDefault(); });
        var email = form.find('input[name="email"]');
        var message = form.find('label.warning');

        $.ajax({
            url: "/forgotten-password-request/",
            dataType: 'json',
            method: 'post',
            data: {
                email: email.val()
            },

            success: function(data) {
                if (data.success) {
                    email.attr('disabled', true).val('');
                    message.html(data.message).show();
                }
                else {
                    message.html(data.message).show();
                }
            }
        });
    }

// Highlight RSVP

    highlightRsvp(status) {
        var goingLocked = (window.eventPage && window.eventPage.goingLocked)
            || $('#event .ev-rsvp--container').data('goingLocked') == 1;

        if (goingLocked) {
            status = 1;
        }

        $('.rsvp-btn-1, .rsvp-btn-2').removeClass('selected disabled locked').each(function() {
            var $btn = $(this);

            if ($btn.hasClass('rsvp-btn-1')) {
                $btn.attr('onclick', 'window.eventPage.rsvp(1); return false;').removeAttr('aria-disabled');
            } else {
                $btn.attr('onclick', 'window.eventPage.rsvp(2); return false;').removeAttr('aria-disabled');
            }
        });

        if (status === 1 || status === 2) {
            var $selected = $('.rsvp-btn-' + status);
            var $other = $('.rsvp-btn-' + (status === 1 ? 2 : 1));

            $selected.addClass('selected');
            $other.addClass('disabled').attr('onclick', 'return false;').attr('aria-disabled', 'true');
        }

        if (goingLocked) {
            var $going = $('.rsvp-btn-1');

            $going.addClass('selected locked').attr('onclick', 'return false;').attr('aria-disabled', 'true');
            $('.rsvp-btn-2').addClass('disabled').attr('onclick', 'return false;').attr('aria-disabled', 'true');
            $('#event .ev-rsvp--container').attr('data-going-locked', '1');
        }
    }

    hideCalendarTooltip() {
        var that = this;

        this.calendarTooltip.addClass('hide');

        window.setTimeout(function() {
            that.calendarTooltip.removeClass();
        }, 250);
    }

    fadeCalendarButton() {
        this.calendarButton.addClass('fadeColor').removeClass('rsvp-1 rsvp-2 rsvp-3');
    }

    sendToAlphaSignupMailChimp(email, name){
        var action= "https://evedo.us18.list-manage.com/subscribe/post?u=1197b653835200fee17c9bcc3&amp;id=bfed5094a2";

        var payload = {};
        var fullName;

        payload.EMAIL = email;
        fullName = name.split(' ');
        payload.FNAME = fullName[0];
        payload.LNAME = fullName[1];

        // Use the (undocumented) MailChimp jsonp api
        var url = action.replace('/post?', '/post-json?') + '&c=?';
        // Add special param to prevent bot signups
        var userId = url.indexOf('u=') + 2;
        userId = url.substring(userId, url.indexOf('&', userId));
        var listId = url.indexOf('id=') + 3;
        listId = url.substring(listId, url.indexOf('&', listId));
        payload['b_' + userId + '_' + listId] = '';

        $.ajax({
          url: url,
          data: payload,
          dataType: 'jsonp'
        }).done(function (resp) {
          var success = resp.result === 'success' || /already/.test(resp.msg);
          if (success) {
            // console.info('MailChimp error: ' + resp.msg);
          }
          // afterSubmit(data);
        }).fail(function () {

        });

    }
}

export { Evedo };
